<template>
  <CIcon
    id="show-hint"
    name="cil-info"
    size="sm"
    class="ml-1"
    :title="showTooltipHint(hint)"
  />
</template>

<style scoped>
#show-hint:hover {
  color: #0056b3;
}
</style>

<script>
import hints from '@/assets/hints/hints.json'

export default {
  name: "ShowHint",
  props: ["hint"],
  methods: {
    showTooltipHint(hintMessage) {
      return hints[hintMessage] || 'Dica não disponível.';
    },
  },
};
</script>
